import styled from "styled-components";
import Text from "common/Typography/Text";
import { hexToRGB } from "@shared/utils/misc";
import { typography } from "@shared/common/Themes/typography";
import { BOTTOM_NAVIGATOR } from "common/constants";

const Link = styled(Text)`
  cursor: pointer;
  color: ${(p) => p.theme.colors.primaryBlue} !important;
  &:hover {
    @media (min-width: ${BOTTOM_NAVIGATOR}) {
      color: ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.8)} !important;
    }
  }
`;

Link.defaultProps = {
  as: "a",
  $weight: typography.fontWeights.NORMAL,
  $size: typography.fontSizes.M,
};

export default Link;
